import { ProfilePhoto } from "@minervaproject/fds";
import React from "react";

import { useAppSelector } from "hooks/redux_hooks";
import { BreakoutRoomType } from "shared/types";
import { UserType } from "shared/types/user";
import { localSelectors } from "store";
import { computeInitials, longDisplayName, profilePhotoUrl, shortRoleForDisplay } from "utils/user";

function StaffUser({ user, breakoutRooms }: { user: UserType; breakoutRooms: BreakoutRoomType[] }) {
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const displayName = longDisplayName(user);
  const role = shortRoleForDisplay(user);
  const isListening = breakoutRooms.some((room) => room.listening_user_ids.includes(user.id));
  const visitingRoom = breakoutRooms.find((room) => room.visiting_user_ids.includes(user.id));
  const isCurrentUserInControlRoom = !breakoutRooms.some((room) =>
    room.visiting_user_ids.includes(currentUserId),
  );
  const room = isListening
    ? "Listening"
    : visitingRoom
      ? `Group ${visitingRoom.title}`
      : isCurrentUserInControlRoom
        ? "Here"
        : "Control Room";
  return (
    <div className="my1 flex items-center">
      <ProfilePhoto
        className={`outline-2-${
          user.is_speaking && !isListening && !visitingRoom ? "green" : "black-tint-10"
        }`}
        size="sm"
        src={profilePhotoUrl(user)}
        initials={computeInitials(user)}
      />
      <div className="body-s text-white mx2 truncate" title={displayName}>
        {displayName}
      </div>
      <div className="body-xs text-black-tint-70 flex-none">
        {role} - {room}
      </div>
    </div>
  );
}

export { StaffUser };
